import { Button, LoadingIndicator } from '@commenda/kakashi';
import React from 'react';

interface OutlinedButtonProps {
  children?: React.ReactNode;
  props?: React.HTMLProps<HTMLButtonElement>;
  additionalStyles?: string;
  spinnerSize?: 'sm' | 'lg';
  type?: 'button' | 'submit';
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const OutlinedButton = ({
  children,
  type,
  onClick,
  additionalStyles,
  isLoading,
  spinnerSize,
  disabled,
  ...props
}: OutlinedButtonProps) => {
  return (
    <Button
      variant="secondary"
      size="sm"
      disabled={disabled}
      onClick={onClick}
      type={type ? 'button' : 'submit'}
      {...props}
    >
      {isLoading ? <LoadingIndicator size={16} /> : children}
    </Button>
  );
};

OutlinedButton.defaultProps = {
  children: undefined,
  props: undefined,
  type: undefined,
  onClick: undefined,
  additionalStyles: '',
};

export default OutlinedButton;
